export default {
    'common.Toolset': "Toolset",
    'login.required':"Please input your username!",
    "login.title": "Welcome to the TPIA Portal_fa",
}